module.exports = __webpack_public_path__ + "img/time.f6989730.png";